import { useCallback, useState } from "react";

import { dispatch } from "../../state/store";
import { setDashboardEmbedUrl } from "../../state/ducks";

import { strCode } from "../../consts";
import { log, notificationService, smartDashboardService, t } from "../../services";

export const useGenerateEmbedUrl = () => {
  const [loading, setLoading] = useState(false);

  const generateEmbedUrl = useCallback(async (id, isQnA) => {
    setLoading(true);

    let result = null;
    try {
      result = isQnA
        ? await smartDashboardService.generateEmbedUrlQna()
        : await smartDashboardService.generateEmbedUrl(id);
      dispatch(setDashboardEmbedUrl(result));
    } catch (err) {
      log.error("useGenerateEmbedUrl: Failed to generate embed url for dashboard " + id, err);
      notificationService.showError({
        title: t(strCode.ERROR_GENERATION_DASHBOARD),
        message: err?.response?.data ? err.response.data : err?.toString()
      });
      dispatch(setDashboardEmbedUrl(null));
    } finally {
      setLoading(false);
    }

    return result;
  }, []);

  return { loading, generateEmbedUrl };
};
